import { Link } from "react-router-dom";
import frame from "../../../assests/HPE/enterpriseone/ent-a/Frame 1171275854.svg";
import hpe from "../../../assests/HPE/enterpriseone/ent-a/HPE-logo-full-clr-pos-rgb (3) 1.png";
const EnterpriseHeader = ({ variant }) => {
  const v = variant?.toLowerCase().trim();

  const bgClass =
    v === "hpe hybrid cloud"
      ? "bg-navy-blue-01"
      : v === "hpe zerto software"
        ? "bg-green-04"
        : "bg-navy-blue-01";
  const link =
    v === "hpe hybrid cloud"
      ? "/"
      : v === "hpe zerto software"
        ? "/zerto"
        : "/";
  return (
    <div className={`w-full  pt-5 md:pb-16 pb-9 flex justify-center ${bgClass}`}>
      <Link to={link}>
        <div
          className="
      flex md:inline-flex
      items-center justify-center
      gap-[46.588px] md:gap-[72px]
      px-[15.529px] py-[12.941px] md:px-6 md:py-5
      rounded-[64.706px] md:rounded-[100px]
      bg-grey-01
      w-full max-w-[368px] md:max-w-fit
      m-auto 
      
    "
        >
          <div className="flex h-[18.118px] items-center gap-[12.94px] md:h-7 md:gap-5">
            {/* LEFT LOGO */}
            <span className="flex items-center">
              <img src={frame} alt="" className="w-[66px] h-auto" />
            </span>

            {/* DIVIDER */}
            <span className="w-[1.75px] h-[24px] bg-grey-02" />

            {/* RIGHT SECTION */}
            <span className="flex items-center gap-4">
              <img
                src={hpe}
                alt=""
                className="w-[56px] h-[16px] object-contain"
              />

              <p className="text-grey-06 text-[13px] md:text-[18px] leading-[26px] font-normal font-google">
                SOLUTION PROVIDER
              </p>
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};
export default EnterpriseHeader;
